import type { SearchGeneModal } from "@/components/windows";

export const useComposable = () => {
    //* 响应式变量
    const refs = {
        keyword: ref<string>(""),
        modal: ref<InstanceType<typeof SearchGeneModal>>(),
    };

    //* 函数列表
    const methods = {
        //* 基因窗口选择回调
        change: (data: any) => routerPush({ name: "MousePhenoPredict", query: { id: data?.id || "" } }),
        //* 搜索事件回调
        search: () => {
            refs.modal.value?.open(refs.keyword.value);
        },
    };

    return { refs, methods };
};
